import * as React from "react";
import { Context } from "./_context";
export const NavigationSendIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.559 1.566a1.5 1.5 0 0 1 1.875 1.875l-6 19.5a1.5 1.5 0 0 1-2.817.141l-3.763-8.937-8.936-3.762a1.5 1.5 0 0 1 .14-2.817l19.5-6ZM5.887 9.22l4.765 2.006 1.671-1.67a.25.25 0 0 1 .354 0l1.767 1.767a.25.25 0 0 1 0 .354l-1.67 1.67 2.006 4.766 3.953-12.846L5.887 9.22Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationSendIcon.iconId = "JKxQE1";
